export default __webpack_public_path__ + "static/media/icon_parents.33156400.png";